import React, { FC } from 'react';

interface IFontProps {
  fontConfig: {
    fontFamily?: string;
    customFontCSS?: string;
    fontUrl?: string;
  };
}

const Font: FC<IFontProps> = ({ fontConfig: { fontFamily, fontUrl, customFontCSS } }) => {
  const renderCustomFontCSS = () => {
    if (customFontCSS) {
      return <style dangerouslySetInnerHTML={{ __html: customFontCSS }} data-testid='font-style-tag' />;
    }

    if (fontUrl) {
      const fontFaceTemplate = `@font-face {
        font-family: "${fontFamily}";
        src: url("${fontUrl}");
        font-display: swap;
      }`;

      return <style dangerouslySetInnerHTML={{ __html: fontFaceTemplate }} data-testid='font-style-tag' />;
    }

    return null;
  };

  const renderFontFamily = () => {
    return (
      <link
        rel='stylesheet'
        href={`https://fonts.googleapis.com/css2?family=${fontFamily}:wght@300;400;700&display=swap" rel="stylesheet"`}
        media='all'
        data-testid='font-link-tag'
      />
    );
  };

  return fontFamily && !customFontCSS && !fontUrl ? renderFontFamily() : renderCustomFontCSS();
};

export default Font;
